import { createContext, useContext } from 'react';
import type { Comment } from '@/core/models/comment';
import type { ToolsState } from './service';

export type Tool =
  | 'search'
  | 'sources'
  | 'snooze'
  | 'bookmark'
  | 'labels'
  | 'update'
  | 'invite'
  | 'quote'
  | 'reply'
  | 'helpful'
  | 'reconsider';
export interface ToolContext {
  state: ToolsState | null;
  ownPost: boolean;
  authenticated: boolean;
  selected: Comment[];
  open: (tool: Tool, comment?: Comment, passage?: string) => void;
  select: (comment: Comment) => void;
  run: (body: Record<string, unknown>) => Promise<void>;
}
export const DiscussionToolsContext = createContext<ToolContext | null>(null);
export const useDiscussionTools = () => useContext(DiscussionToolsContext);
